
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4426|68334)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
